import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        // this.onScroll();
        this.addSmoothScroll();
    }

    onScroll() {
        const revealElm = document.querySelectorAll(".js-scrollreveal");

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 75%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });
    }

    addSmoothScroll() {
        const $triggerArray = [
            ...document.querySelectorAll(".js-smoothscroll"),
        ];

        $triggerArray.forEach(($trigger) => {
            $trigger.addEventListener("click", (e) =>
                this.setSmoothScroll(e, $trigger)
            );
        });
    }

    setSmoothScroll(e, $trigger) {
        e.preventDefault();

        const elm = $trigger;

        const offset = 0;

        if (elm.classList.contains("-collabo")) {
            if (window.innerWidth >= 768) {
                scrollSet = 144;
            } else {
                var scrollSet = 64;
            }
        } else {
            scrollSet = offset;
        }

        const y = e.currentTarget.hash || 0,
            scrollTo = { y: y, offsetY: scrollSet };

        gsap.to(window, {
            duration: 0.8,
            scrollTo: scrollTo,
            ease: "expo.inOut",
        });
    }
}
